__turbopack_context__.v({
  "buttons-container": "sz_aFW_buttons-container",
  "clear-button": "sz_aFW_clear-button",
  "input": "sz_aFW_input",
  "input-icon": "sz_aFW_input-icon",
  "search-bar": "sz_aFW_search-bar",
  "wrapper": "sz_aFW_wrapper",
});
